module.exports = __webpack_public_path__ + "img/ulster-rugby-logo-icon.b98b8599.png";